import _core from "./core";
import * as _unidragger2 from "unidragger";

var _unidragger = "default" in _unidragger2 ? _unidragger2.default : _unidragger2;

import * as _fizzyUiUtils2 from "fizzy-ui-utils";

var _fizzyUiUtils = "default" in _fizzyUiUtils2 ? _fizzyUiUtils2.default : _fizzyUiUtils2;

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

// drag
(function (window, factory) {
  // universal module definition
  if (exports) {
    // CommonJS
    exports = factory(window, _core, _unidragger, _fizzyUiUtils);
  } else {
    // browser global
    window.Flickity = factory(window, window.Flickity, window.Unidragger, window.fizzyUIUtils);
  }
})(typeof window != "undefined" ? window : exports, function factory(window, Flickity, Unidragger, utils) {
  // ----- defaults ----- //
  Object.assign(Flickity.defaults, {
    draggable: ">1",
    dragThreshold: 3
  }); // -------------------------- drag prototype -------------------------- //

  let proto = Flickity.prototype;
  Object.assign(proto, Unidragger.prototype); // inherit Unidragger

  proto.touchActionValue = ""; // --------------------------  -------------------------- //

  Flickity.create.drag = function () {
    this.on("activate", (this || _global).onActivateDrag);
    this.on("uiChange", (this || _global)._uiChangeDrag);
    this.on("deactivate", (this || _global).onDeactivateDrag);
    this.on("cellChange", (this || _global).updateDraggable);
    this.on("pointerDown", (this || _global).handlePointerDown);
    this.on("pointerUp", (this || _global).handlePointerUp);
    this.on("pointerDown", (this || _global).handlePointerDone);
    this.on("dragStart", (this || _global).handleDragStart);
    this.on("dragMove", (this || _global).handleDragMove);
    this.on("dragEnd", (this || _global).handleDragEnd);
    this.on("staticClick", (this || _global).handleStaticClick); // TODO updateDraggable on resize? if groupCells & slides change
  };

  proto.onActivateDrag = function () {
    (this || _global).handles = [(this || _global).viewport];
    this.bindHandles();
    this.updateDraggable();
  };

  proto.onDeactivateDrag = function () {
    this.unbindHandles();

    (this || _global).element.classList.remove("is-draggable");
  };

  proto.updateDraggable = function () {
    // disable dragging if less than 2 slides. #278
    if ((this || _global).options.draggable === ">1") {
      (this || _global).isDraggable = (this || _global).slides.length > 1;
    } else {
      (this || _global).isDraggable = (this || _global).options.draggable;
    }

    (this || _global).element.classList.toggle("is-draggable", (this || _global).isDraggable);
  };

  proto._uiChangeDrag = function () {
    delete (this || _global).isFreeScrolling;
  }; // -------------------------- pointer events -------------------------- //


  proto.handlePointerDown = function (event) {
    if (!(this || _global).isDraggable) {
      // proceed for staticClick
      this.bindActivePointerEvents(event);
      return;
    }

    let isTouchStart = event.type === "touchstart";
    let isTouchPointer = event.pointerType === "touch";
    let isFocusNode = event.target.matches("input, textarea, select");
    if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
    if (!isFocusNode) this.focus(); // blur

    if (document.activeElement !== (this || _global).element) document.activeElement.blur(); // stop if it was moving

    (this || _global).dragX = (this || _global).x;

    (this || _global).viewport.classList.add("is-pointer-down"); // track scrolling


    (this || _global).pointerDownScroll = getScrollPosition();
    window.addEventListener("scroll", this || _global);
    this.bindActivePointerEvents(event);
  }; // ----- move ----- //


  proto.hasDragStarted = function (moveVector) {
    return Math.abs(moveVector.x) > (this || _global).options.dragThreshold;
  }; // ----- up ----- //


  proto.handlePointerUp = function () {
    delete (this || _global).isTouchScrolling;

    (this || _global).viewport.classList.remove("is-pointer-down");
  };

  proto.handlePointerDone = function () {
    window.removeEventListener("scroll", this || _global);
    delete (this || _global).pointerDownScroll;
  }; // -------------------------- dragging -------------------------- //


  proto.handleDragStart = function () {
    if (!(this || _global).isDraggable) return;
    (this || _global).dragStartPosition = (this || _global).x;
    this.startAnimation();
    window.removeEventListener("scroll", this || _global);
  };

  proto.handleDragMove = function (event, pointer, moveVector) {
    if (!(this || _global).isDraggable) return;
    event.preventDefault();
    (this || _global).previousDragX = (this || _global).dragX; // reverse if right-to-left

    let direction = (this || _global).options.rightToLeft ? -1 : 1; // wrap around move. #589

    if ((this || _global).isWrapping) moveVector.x %= (this || _global).slideableWidth;
    let dragX = (this || _global).dragStartPosition + moveVector.x * direction;

    if (!(this || _global).isWrapping) {
      // slow drag
      let originBound = Math.max(-(this || _global).slides[0].target, (this || _global).dragStartPosition);
      dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
      let endBound = Math.min(-this.getLastSlide().target, (this || _global).dragStartPosition);
      dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
    }

    (this || _global).dragX = dragX;
    (this || _global).dragMoveTime = new Date();
  };

  proto.handleDragEnd = function () {
    if (!(this || _global).isDraggable) return;
    let {
      freeScroll
    } = (this || _global).options;
    if (freeScroll) (this || _global).isFreeScrolling = true; // set selectedIndex based on where flick will end up

    let index = this.dragEndRestingSelect();

    if (freeScroll && !(this || _global).isWrapping) {
      // if free-scroll & not wrap around
      // do not free-scroll if going outside of bounding slides
      // so bounding slides can attract slider, and keep it in bounds
      let restingX = this.getRestingPosition();
      (this || _global).isFreeScrolling = -restingX > (this || _global).slides[0].target && -restingX < this.getLastSlide().target;
    } else if (!freeScroll && index === (this || _global).selectedIndex) {
      // boost selection if selected index has not changed
      index += this.dragEndBoostSelect();
    }

    delete (this || _global).previousDragX; // apply selection
    // HACK, set flag so dragging stays in correct direction

    (this || _global).isDragSelect = (this || _global).isWrapping;
    this.select(index);
    delete (this || _global).isDragSelect;
  };

  proto.dragEndRestingSelect = function () {
    let restingX = this.getRestingPosition(); // how far away from selected slide

    let distance = Math.abs(this.getSlideDistance(-restingX, (this || _global).selectedIndex)); // get closet resting going up and going down

    let positiveResting = this._getClosestResting(restingX, distance, 1);

    let negativeResting = this._getClosestResting(restingX, distance, -1); // use closer resting for wrap-around


    return positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
  };
  /**
   * given resting X and distance to selected cell
   * get the distance and index of the closest cell
   * @param {Number} restingX - estimated post-flick resting position
   * @param {Number} distance - distance to selected cell
   * @param {Integer} increment - +1 or -1, going up or down
   * @returns {Object} - { distance: {Number}, index: {Integer} }
   */


  proto._getClosestResting = function (restingX, distance, increment) {
    let index = (this || _global).selectedIndex;
    let minDistance = Infinity;
    let condition = (this || _global).options.contain && !(this || _global).isWrapping ? // if containing, keep going if distance is equal to minDistance
    (dist, minDist) => dist <= minDist : (dist, minDist) => dist < minDist;

    while (condition(distance, minDistance)) {
      // measure distance to next cell
      index += increment;
      minDistance = distance;
      distance = this.getSlideDistance(-restingX, index);
      if (distance === null) break;
      distance = Math.abs(distance);
    }

    return {
      distance: minDistance,
      // selected was previous index
      index: index - increment
    };
  };
  /**
   * measure distance between x and a slide target
   * @param {Number} x - horizontal position
   * @param {Integer} index - slide index
   * @returns {Number} - slide distance
   */


  proto.getSlideDistance = function (x, index) {
    let len = (this || _global).slides.length; // wrap around if at least 2 slides

    let isWrapAround = (this || _global).options.wrapAround && len > 1;
    let slideIndex = isWrapAround ? utils.modulo(index, len) : index;
    let slide = (this || _global).slides[slideIndex];
    if (!slide) return null; // add distance for wrap-around slides

    let wrap = isWrapAround ? (this || _global).slideableWidth * Math.floor(index / len) : 0;
    return x - (slide.target + wrap);
  };

  proto.dragEndBoostSelect = function () {
    // do not boost if no previousDragX or dragMoveTime
    if ((this || _global).previousDragX === undefined || !(this || _global).dragMoveTime || // or if drag was held for 100 ms
    new Date() - (this || _global).dragMoveTime > 100) {
      return 0;
    }

    let distance = this.getSlideDistance(-(this || _global).dragX, (this || _global).selectedIndex);
    let delta = (this || _global).previousDragX - (this || _global).dragX;

    if (distance > 0 && delta > 0) {
      // boost to next if moving towards the right, and positive velocity
      return 1;
    } else if (distance < 0 && delta < 0) {
      // boost to previous if moving towards the left, and negative velocity
      return -1;
    }

    return 0;
  }; // ----- scroll ----- //


  proto.onscroll = function () {
    let scroll = getScrollPosition();
    let scrollMoveX = (this || _global).pointerDownScroll.x - scroll.x;
    let scrollMoveY = (this || _global).pointerDownScroll.y - scroll.y; // cancel click/tap if scroll is too much

    if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
      this.pointerDone();
    }
  }; // ----- utils ----- //


  function getScrollPosition() {
    return {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  } // -----  ----- //


  return Flickity;
});

export default exports;